import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { getAllMenuItems } from "../menu/menuConfig";

// The browser tab's title: "BML", then whatever the page is about, joined with dashes —
// "BML - Langerman 71400 - Image analysis", "BML - Fancy Intense Blue - Pricing", or just
// "BML - Visual picker" where the page is about nothing in particular.
//
// Parts are given in order and the empty ones dropped, so a page can pass a subject that is not
// loaded yet and get the plain title until it is. A page that passes nothing falls back to its menu
// label, which is why most pages need say nothing at all.
// How a stone is named in a title: "Langerman 71400", the same way the diamond header names it.
// Undefined while the stone is still loading, which drops it from the title until it arrives.
export const stoneName = (diamond: any): string | undefined =>
  diamond?.sKU ? `${diamond.source} ${diamond.sKU}` : undefined;

export function useDocumentTitle(...parts: (string | null | undefined)[]) {
  const { pathname } = useLocation();
  const menuLabel = getAllMenuItems().find((item) =>
    matchPath(item.path, pathname),
  )?.label;

  const named = parts.filter(Boolean);
  const title = ["BML", ...(named.length > 0 ? named : [menuLabel])]
    .filter(Boolean)
    .join(" - ");

  useEffect(() => {
    document.title = title;
  }, [title]);
}

export default useDocumentTitle;
